export default {"src":"/_next/static/media/star.1b8e3785.svg","height":67,"width":68,"blurWidth":0,"blurHeight":0};